import React, { forwardRef, useRef } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import { FeatureFlags, getFeatureFlag } from "../../utilities/featureFlags";
import { parseCss } from "../../utilities/parseCss";
import classNames from "classnames";
import { useScript } from "../Hooks/useScript";
import Picture from "../Picture";

export interface IMarkdownProps extends IEditableProps, IStyledProps {
    children;
    cssStyle: string;
    javascript: string;
    runScript: boolean;
}

const Markdown = styled(forwardRef((props: IMarkdownProps, ref: any) => {
    const innerRef = useRef(ref);
    const enableWebp = getFeatureFlag(FeatureFlags.PREFER_WEBP_IMAGES);
    const enableWebpCss = getFeatureFlag(FeatureFlags.PREFER_WEBP_IMAGES_CSS);

    useScript(props.javascript, props.runScript);

    const replaceChildren = (children, parent = null) => {
        
        return React.Children.map(children, child => {
            const childType = child.props?.originalType;
            const parentType = parent?.props?.originalType;
            if (child.props?.children) {
                if (typeof child.props?.children === "string") {
                    return React.cloneElement(child, child.props, child.props.children.replace(/Ϲ/g, "{").replace(/Ͻ/g, "}"));
                } else {
                    return React.cloneElement(child, child.props, replaceChildren(child.props.children, child));
                }

            } else if (childType === 'img' && parentType !== 'picture' && enableWebp) {
                const { ['data-test-id']: dataTestId, originalType, mdxType, ...props} = child.props;
                const loading = props.loading || 'lazy';
                return <Picture { ...props} loading={loading} dataTestId={dataTestId} />
            } else {
                return child;
            }
        }); 
    } 

    return (
        <>
            {props.cssStyle && (
                <style>
                    {enableWebpCss ? 
                        parseCss(props.cssStyle)
                    :
                        props.cssStyle.replace(/\n/g, '').replace(/\s\s+/g, ' ')
                    }         
                </style>
            )}
            <div data-id={props.cmsId} ref={innerRef} className={classNames(props.className, props.editorClassObj, 'custom-content', 'markdown-container')}>
                {replaceChildren(props.children)}
            </div>
        </>
    );
}))`
    &:empty {
        width: 100%;
        min-height: 300px;
        background: #fafafa;
    }
`;

export default Markdown;